export default {
  'cashFlow.label.status': 'Status',
  'cashFlow.label.filterByDate': 'Filter by date',
  'cashFlow.label.reportType': 'Select report type',
  'cashFlow.label.show': 'Show:',
  'cashFlow.label.moreOptions': 'More Options',
  'cashFlow.label.bankAccount': 'Bank account',

  'cashFlow.option.open': 'Open',
  'cashFlow.option.liquidated': 'Liquidated',
  'cashFlow.option.expiration': 'Expiration',
  'cashFlow.option.payment': 'Payment',
  'cashFlow.option.emission': 'Emission',
  'cashFlow.option.weekly': 'Weekly',
  'cashFlow.option.period': 'Monthly',
  'cashFlow.option.daily': 'Daily',

  'cashFlow.checkbox.synthetic': 'Synthetic?',
  'cashFlow.checkbox.accPayableReceivable': 'Accounts Payable/Receivable',
  'cashFlow.checkbox.tariffs': 'Tariffs',
  'cashFlow.checkbox.singleRelease': 'Single Release',
};
